'use client';
import { getClientApplicationConfig } from '@hc-frontend/core-context';

import { datadogRumAdapter } from '../../adapters/datadog-rum';

export function initializeDatadogRum(): void {
  const config = getClientApplicationConfig();

  datadogRumAdapter({
    applicationId: config.datadog.applicationId,
    clientToken: config.datadog.clientToken,
    site: config.datadog.site,
    service: config.datadog.service,
    env: config.core.appEnvironment,
    version: config.core.version,
  });
}
